import React, { Component } from "react";
import { connect } from "react-redux";
import { CloseIcon } from '../common/icons/svg'
import { renderImg } from "../common/icons/img";
let counter = 1;

class LinkAutocomplete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // value: "",
            focus: false,
        };
    }
    handleKeyPress = (event) => {
        if (this.state.focus) {
            if (event.key === "ArrowDown") {
                if (this.refs["atc" + (counter + 1)]) counter++;
                if (this.refs["atc" + (counter - 1)] && this.refs["atc" + counter])
                    this.refs["atc" + (counter - 1)].style = "";
                if (this.refs["atc" + counter]) {
                    // console.log(this.refs["atc" + counter].style);
                    this.refs["atc" + counter].style = "background:#e5e5e5";
                    this.refs.atc.scrollTop = (counter - 1) * 37;
                }
            }
            if (event.key === "ArrowUp") {
                if (counter !== 1) counter--;
                if (this.refs["atc" + (counter + 1)] && this.refs["atc" + counter])
                    this.refs["atc" + (counter + 1)].style = "";
                if (this.refs["atc" + counter]) {
                    this.refs["atc" + counter].style = "background:#e5e5e5";
                    this.refs.atc.scrollTop = (counter - 1) * 37;
                }
            }
            if (event.key === "Tab") {
                this.props.setValue(this.refs["atc" + counter].innerHTML, true);
                this.setState({ focus: false });
                counter = 1;
            }
            if (event.key === "Enter") {
                this.props.setValue(this.refs["atc" + counter].innerHTML, true);
                this.setState({ focus: false });
                counter = 1;
            }
        }
    };

    selCity = (city) => {
        this.props.setValue(city, true);
        this.setState({ focus: false });
    };

    selStophour = (val) => {
        this.props.setValue(val, true);
        this.setState({ focus: false });
    }

    showStopHour = (list) => {
        let i = 0;
        const loop = list;
        const stophour = this.props.value;
        return loop.map((el, index) => {
            if (el === stophour) {
                i++;
                return (
                    <div key={index} ref={"atc" + i} onClick={() => this.selStophour(el)}>
                        {index === 0 ? 'No Prefences' : el + ' Hours'}
                    </div>
                );
            } else {
                return (
                    <div key={index} ref={"atc" + i} onClick={() => this.selStophour(el)}>
                        {index === 0 ? 'No Prefences' : el + ' Hours'}
                    </div>
                );
            }
        })
    }

    showDropDown = () => {
        if (this.props.list.length > 0) {
            return (
                <div className="atc" ref="atc">
                    {/* {this.props.type === 'linkCity' && this.showLinkCityAtc(this.props.list)} */}
                    {this.props.type === 'stophour' ? this.showStopHour(this.props.list) : this.showAtc(this.props.list)}

                </div>
            );
        } else {
            return (
                <div ref="atc">
                    <div>Loading...</div>
                </div>
            );
        }
    };

    showAtc = (list) => {
        let i = 0;
        const loop = list;
        const city = this.props.value;
        if (this.props.type === 'linkCity') {
            return loop.map((el, index) => {
                if (el.LinkCity.toLowerCase().indexOf(city.toLowerCase()) === 0) {
                    i++;
                    return (
                        <div key={index} ref={"atc" + i} onClick={() => this.selCity(el.LinkCity)}>
                            {el.LinkCity}
                        </div>
                    );
                } else {
                    return "";
                }
            });
        } else {
            return loop.map((el, index) => {
                if (el.toLowerCase().indexOf(city.toLowerCase()) === 0) {
                    i++;
                    return (
                        <div key={index} ref={"atc" + i} onClick={() => this.selCity(el)}>
                            {el}
                        </div>
                    );
                } else {
                    return "";
                }
            });
        }
    };

    render() {
        return (
            <div
                style={this.props.style}
                className={this.props.className ? this.props.className : ""}
            >
                <input
                    type="text"
                    placeholder={this.props.placeholder}
                    value={this.props.value}
                    onChange={(event) => this.props.setValue(event.target.value, false)}
                    onFocus={() => this.setState({ focus: true })}
                    onBlur={() =>
                        setTimeout(() => {
                            this.setState({ focus: false });
                        }, 500)
                    }
                    onKeyDown={this.handleKeyPress}
                    className={`ty-text ${this.state.focus ? 'inp--focus' : ''}`}
                    style={this.props.inpS ? this.props.inpS : this.inpS}
                />
                {this.state.focus ? this.showDropDown() : ""}
                {this.props.label ? <label style={{ left: '16px' }}>{this.props.label}</label> : ""}
                {this.props.value ? (
                    <span
                        className={this.props.spanclassname ? this.props.spanclassname : ""}
                        style={{ right: '16px' }}
                        onClick={(e) => {
                            e.stopPropagation();
                            this.props.setValue("", true);
                            this.setState({ focus: true });
                        }}
                    >
                        {/* <CloseIcon /> */}
                        {renderImg('CloseIcon')}
                    </span>
                ) : (
                    ""
                )}
            </div>
        );
    }

    getBackground = () => {
        if (this.props.err) {
            return "rgba(255, 0, 0, 0.2)";
        }
        else if (this.props.type === 'startCity') {
            if (this.props.linkCity.toLowerCase() === this.props.search.searchParams.fromCity.split("|")[1].toLowerCase()) {
                return "#eee";
            } else {
                return "#E8F7ED";
            }
        }
        else if (this.props.type === 'toCity') {
            if (this.props.linkCity.toLowerCase() !== this.props.search.searchParams.fromCity.split("|")[1].toLowerCase()) {
                return "#eee";
            } else {
                return "#E8F7ED";
            }
        }
        else {
            return "#E8F7ED";
        }
    }

    inpS = {
        width: "100%",
        background: this.props.type === 'stophour' ? "#fff" : this.getBackground(),
        padding: this.props.inputpadding ? this.props.inputpadding : "15px",
        border: "0",
        outline: "0",
        borderRight: this.props.inputborder
            ? this.props.inputborder
            : "1px solid #ddd",
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'no-wrap',
    };
}

const mapStateToProps = function (store) {
    return store;
};

export default connect(mapStateToProps)(LinkAutocomplete);
